import React = require("react");
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import {TerminalAddAlarmNotePanel} from "./PredictiveMaintenanceTerminalDummyWorkOrderNode";
import "./PredictiveMaintenanceWizard.scss";

declare var AppTranslations: AppTranslations;

interface PredictiveMaintenanceNotFoundNodeProps {
    alarmId: number;
    openWorkOrder: () => void;
    alarmData: any;
    alarmPanel: any;
}

interface PredictiveMaintenanceNotFoundNodeState {
    alarmId: number;
    showLoader: boolean;
}

export class PredictiveMaintenanceNotFoundNode
    extends React.Component<PredictiveMaintenanceNotFoundNodeProps, PredictiveMaintenanceNotFoundNodeState> {
    constructor(props: PredictiveMaintenanceNotFoundNodeProps) {
        super(props);
        this.state = {alarmId: this.props.alarmId, showLoader: false};
    }

    public render() {
        return (
            <div className="alarmPanelQuestion alarmPanelTerminalQuestionTitleContent">
                {!this.props.alarmData.useDummyWorkOrder ?
                    <div
                        className="alarmPanelTerminalQuestionButtonContent alarm-panel-predictive-not-found alarmDetailButtonWrapper"
                        onClick={this.openWorkOrder()}
                    >
                        <div
                            className="alarmDetailButton alarm-detail-button-predictive-not-found"
                        >
                            <div className="onButton">
                                <div className="icon alarmOpenWorkOrderIcon"/>
                            </div>
                            <div className="icon alarmOpenWorkOrderIcon"/>
                        </div>
                        <p className="alarmOpenWorkOrderIconText">
                            {AppTranslations.predictiveTranslation.openWorkOrderTitle}
                        </p>
                    </div> :
                    <TerminalAddAlarmNotePanel
                        alarmGuid={this.props.alarmData.alarmGuid}
                        alarmPanel={this.props.alarmPanel}
                    />
                }
            </div>
        );
    }

    private openWorkOrder = () => (event: any) => {
        this.setState({showLoader: true});
        this.props.openWorkOrder();
    }
}
